import { observer } from 'mobx-react'
import orderBy from 'lodash/orderBy'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { ColumnFilterProps } from '@new/domains/operations/screens/CasesV2/CasesV2.types'
import { casesFilterOptionsStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFilterOptionsStore'
import { casesFiltersStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFiltersStore'
import { CaseFilterIds } from '@new/domains/operations/screens/CasesV2/utils/config'

import * as S from './commonFilterStyles.style'

const _CaseOwnersFilter = (props: ColumnFilterProps) => {
  const { ownersInSelectedRegions, isLoadingCaseOwners } = casesFilterOptionsStore
  const { caseOwners, setFilterValue } = casesFiltersStore

  const handleDataFilter = (value?: string[]) => {
    setFilterValue(CaseFilterIds.CaseOwner, value)
  }

  const filterOptions =
    orderBy(ownersInSelectedRegions?.map(user => ({
      value: user.id,
      label: user.name.trim(),
    })) ?? [], 'label')

  return (
    <S.CheckBoxWrapper>
      <CheckboxBasedFilter
        title="Case Owners"
        options={filterOptions}
        isLoadingOptions={isLoadingCaseOwners}
        initialValue={caseOwners}
        onChange={handleDataFilter}
        {...props}
      />
    </S.CheckBoxWrapper>
  )
}

export const CaseOwnersFilter = observer(_CaseOwnersFilter)
